import { PayloadAction, createSlice } from '@reduxjs/toolkit';

type SelectorState = { appSettings: AppSettingsState };

export type AppSettingsState = {
  withTabBar: boolean;
};

export const initialAppSettingsState: AppSettingsState = {
  withTabBar: false,
};

export const appSettinsSlice = createSlice({
  name: 'appSettings',
  initialState: initialAppSettingsState,
  reducers: {
    setWithTabBar: (state, action: PayloadAction<boolean>) => {
      state.withTabBar = action.payload;
    },
  },
});

export const withTabBar = (state: SelectorState) =>
  state.appSettings.withTabBar;

export const { setWithTabBar } = appSettinsSlice.actions;

export default appSettinsSlice.reducer;
